import LoginSwitcher from "./modules/main/components/LoginSwitcher.tsx";
import { useBuildUpdateState } from "shared-components";
import BuildUpdateBanner from "./modules/main/components/BuildUpdateBanner.tsx";
import { buildUpdateController } from "./modules/main/components/buildUpdate";

const Root = () => {
  const buildUpdateState = useBuildUpdateState(buildUpdateController);
  const showUpdateBanner =
    buildUpdateState.isUpdateAvailable &&
    buildUpdateState.updateMode === "confirm";

  return (
    <div>
      {showUpdateBanner ? (
        <BuildUpdateBanner
          isApplyingUpdate={buildUpdateState.isApplyingUpdate}
          onApplyUpdate={buildUpdateController.applyPendingUpdate}
        />
      ) : null}
      <div className={showUpdateBanner ? "pt-32 md:pt-28" : undefined}>
        <LoginSwitcher />
      </div>
    </div>
  );
};

export default Root;
